import { getFileCollectionContainer } from '@/services/implementationmanagement.api';
import { formatDateToWrittenDate } from '@/helpers/dates';

export async function buildFileCollection (taskId) {

    // Call identity verification API to get the status of the identity verification process
    var response = await getFileCollectionContainer(taskId);

    if(response.status !== 200 || response.data === null || response.data === undefined) {
        console.error('Error fetching data collection task');
        return null;
    }

    const task = response.data;

    const card = {
    id: task.taskId,
    title: task.taskName,
    subtitle: 'Provide us with your payroll data to allow us to setup your payroll',
    progress: 0,
    subProgressMessage: '',
    status: task.taskStatus,
    route: '/tasks/file-collection/' + task.taskId, 
    createdDate: new Date(task.createdDate)
  }
    
  return card 
}

